namespace RioERP.Masters {
    export interface BrandAmbassadorSettingsRow {
        Id?: number;
        CouponCodePrefix?: string;
        RunProgram?: boolean;
        SendEmails?: boolean;
        CreateGiftCard?: boolean;
        OnOrOff?: boolean;
        DiscountCreateNopUrl?: string;
        CreateNopTokenUrl?: string;
        CreateGiftCardUrl?: string;
        NopEmail?: string;
        SiteUrl?: string;
        NopUserName?: string;
        NopPassword?: string;
        DiscountCategoryMappingNopUrl?: string;
        DiscountPercentage?: number;
        BrandAmbassadorSharePercentage?: number;
        DiscountCategoryId?: number;
    }

    export namespace BrandAmbassadorSettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CouponCodePrefix';
        export const localTextPrefix = 'Masters.BrandAmbassadorSettings';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CouponCodePrefix = "CouponCodePrefix",
            RunProgram = "RunProgram",
            SendEmails = "SendEmails",
            CreateGiftCard = "CreateGiftCard",
            OnOrOff = "OnOrOff",
            DiscountCreateNopUrl = "DiscountCreateNopUrl",
            CreateNopTokenUrl = "CreateNopTokenUrl",
            CreateGiftCardUrl = "CreateGiftCardUrl",
            NopEmail = "NopEmail",
            SiteUrl = "SiteUrl",
            NopUserName = "NopUserName",
            NopPassword = "NopPassword",
            DiscountCategoryMappingNopUrl = "DiscountCategoryMappingNopUrl",
            DiscountPercentage = "DiscountPercentage",
            BrandAmbassadorSharePercentage = "BrandAmbassadorSharePercentage",
            DiscountCategoryId = "DiscountCategoryId"
        }
    }
}
